import { render, staticRenderFns } from "./ServiceProviderForm.vue?vue&type=template&id=bab4cab2&scoped=true"
import script from "./ServiceProviderForm.vue?vue&type=script&lang=js"
export * from "./ServiceProviderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab4cab2",
  null
  
)

export default component.exports